const formInitialValues = (practice) => {
  return {
    displaySettings: practice?.display_settings || null,
    headerPhoto: practice?.header_photo || null,
    address: {
      address_ln_1: practice?.practiceAddress?.address_ln_1,
      address_ln_2: practice?.practiceAddress?.address_ln_2,
      city: practice?.practiceAddress?.city,
      state: practice?.practiceAddress?.state,
      zip: practice?.practiceAddress?.zip
    },
    surchargeAmount: (practice?.surcharge_percentage ?? 0) * 100,
    surchargeEnabled: practice?.surcharge_enabled || false
  };
};

export default formInitialValues;
